import ValidatableObject from "../validation/ValidatableObject";
import Model from "../Model";

export interface TReport1Applicant {
  id: number;
  partyId: number;
  name: string;
  lastName: string;
}

export interface IReport1Applicant extends TReport1Applicant {
  fullName: string;
}

const Report1Applicant = Model(
  (model: TReport1Applicant): IReport1Applicant => {
    const _applicantData: TReport1Applicant = Object.assign({}, model);

    let create = (applicantData: IReport1Applicant): IReport1Applicant => {
      let obj = ValidatableObject(applicantData);
      return obj;
    };

    let applicantData = {
      get id() {
        return _applicantData.id;
      },
      set id(value) {
        _applicantData.id = value;
      },
      get partyId() {
        return _applicantData.partyId;
      },
      set partyId(value) {
        _applicantData.partyId = value;
      },
      get name() {
        return _applicantData.name;
      },
      set name(value) {
        _applicantData.name = value;
      },
      get lastName() {
        return _applicantData.lastName;
      },
      set lastName(value) {
        _applicantData.lastName = value;
      },
      get fullName() {
        return `${this.name} ${this.lastName}`;
      }
    };
    return create(applicantData);
  }
);

export default Report1Applicant;
